import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import MuiSwitch from "@mui/material/Switch";
import { Field } from "react-final-form";

interface SwitchProps {
  name: string;
  label?: string;
  helperText?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  [key: string]: any;
}

export function Switch(props: SwitchProps) {
  return (
    <Field
      {...props}
      type="checkbox"
      render={(fieldProps: any) => {
        const {
          input: { value, ...restInput },
          helperText,
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          meta,
          disabled,
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          fullWidth,
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          editData,
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          allValues,
          ...rest
        } = fieldProps;
        return (
          <FormControl disabled={disabled}>
            <FormControlLabel
              control={<MuiSwitch disabled={disabled} color="primary" />}
              checked={value}
              disabled={disabled}
              {...restInput}
              {...rest}
            />
            {helperText && (
              <FormHelperText sx={{ marginLeft: 0 }}>
                {helperText}
              </FormHelperText>
            )}
          </FormControl>
        );
      }}
    />
  );
}
